import React, { useContext } from 'react';
import ThemePanel from '../panels/ThemePanel';
import TextFieldsPanel from '../panels/TextFieldsPanel';
import ModalStylingPanel from '../panels/ModalStylingPanel';
import ButtonStylingPanel from '../panels/ButtonStylingPanel';
import TextFieldStylingPanel from '../panels/TextFieldStylingPanel';
import LeadingQuestionPanel from '../panels/LeadingQuestionPanel';
import CountdownPanel from '../panels/CountdownPanel';
import { ListWrapper } from '../Steps/components';
import UrlTargetPanel from '../panels/UrlTargetPanel';
import WebformOptionsPanel from '../panels/WebformOptionsPanel';
import PhoneNumberPanel from '../panels/PhoneNumberPanel';
import SocialProfilePanel from '../panels/SocialProfilePanel';
import ImagePanel from '../panels/ImagePanel';
import HeadlinePanel from '../panels/HeadlinePanel';
import CTAPanel from '../panels/CTAPanel';
import NoThanksPanel from '../panels/NoThanksPanel';
import Subheadline1Panel from '../panels/Subheadline1Panel';
import Subheadline2Panel from '../panels/Subheadline2Panel';
import GamificationPanel from '../panels/GamificationPanel';
import GamificationRewardsPanel from '../panels/GamificationRewardsPanel';
import FormBuilderPanel from '../panels/FormBuilderPanel';
import FormStylingPanel from '../panels/FormStylingPanel';
import { EditorContext } from '../../../utils/contexts';

export default function ModalDesign({ featureType = 'popup' }) {
  const { settings } = useContext(EditorContext);
  const isGamification =
    settings.element_subtype === 'gamification' ||
    settings.subtype === 'gamification';
  // Use both the featureType prop AND settings subtype as signals
  const isForms =
    featureType === 'forms' ||
    settings.element_subtype === 'forms' ||
    settings.subtype === 'forms' ||
    !!settings.form_type;

  if (isForms) {
    return (
      <ListWrapper>
        <ThemePanel />
        <ModalStylingPanel />
        <Subheadline1Panel />
        <FormStylingPanel />
        <FormBuilderPanel />
        <ImagePanel />
        <ButtonStylingPanel />
      </ListWrapper>
    );
  }

  // In forms popup flow (featureType=popup but isForms by subtype), show builder inline
  const isFormsPopup =
    settings.element_subtype === 'forms' ||
    settings.subtype === 'forms' ||
    !!settings.form_type ||
    (Array.isArray(settings.form_questions) && settings.form_questions.length > 0);

  return (
    <ListWrapper>
      <ThemePanel />
      <ModalStylingPanel />
      <HeadlinePanel />
      <Subheadline1Panel />
      <Subheadline2Panel />
      {isGamification && <GamificationPanel />}
      {isGamification && <GamificationRewardsPanel />}
      {isFormsPopup && <FormBuilderPanel />}
      <TextFieldsPanel />
      <TextFieldStylingPanel />
      <PhoneNumberPanel />
      <SocialProfilePanel />
      <WebformOptionsPanel />
      <ImagePanel />
      <UrlTargetPanel />
      <CTAPanel />
      <ButtonStylingPanel />
      <NoThanksPanel />
      <LeadingQuestionPanel />
      <CountdownPanel />
    </ListWrapper>
  );
}
